/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const CustomerPage = lazyLoad(
  () => import('./index'),
  module => module.CustomerPage
);
